'use strict';

angular.module('far.events').controller('EventRequestController', function ($window, $log, $scope, $rootScope, $timeout, event, eventRequestForm, mountainRegions, FileUploader, Geocoder, maps) {
    var geocoder = new Geocoder();

    var vm = {
        progress: true,
        submitted: false,
        init: init,
        submit: submit,
        requestForm: eventRequestForm,
        form: {},
        club: {},
        eventType: null,
        getDocumentUrl: getDocumentUrl,
        accepted: function () {
            vm.form.event_application.accepted = vm.requestForm.$fields.accepted.items[1];

            vm.submit();
        },
        reject: function () {
            vm.form.event_application.accepted = vm.requestForm.$fields.accepted.items[2];

            vm.submit();
        },
        map: {
            center: maps.getDefaultCenter(),
            zoom: maps.getDefaultZoom(),
            markers: [],
            disableDefaultUI: true,
            scrollwheel: false,
            events: {
                click: function (map, eventName, event) {
                    var marker = geocoder.getLatLngObject(event[0].latLng);
                    marker.id = 1;
                    vm.map.markers = [marker];
                }
            }
        },
        changeDocument: function ($index, document) {
            if (!vm.form.event_application.documents[$index]) {
                vm.form.event_application.documents[$index] = document;
            } else {
                delete vm.form.event_application.documents[$index];
            }
        },
        updateName: function() {
            if (vm.form.event_application.club) {
                vm.form.name = 'Альпмероприятие ' + vm.form.event_application.club.name;
            }
        }
    };

    vm.requestForm.$fields.club.uiSelectOptions.onSelect = function (item) {
        vm.form.event_application.club = item ? item : null;
        vm.updateName();
    };
    vm.requestForm.$fields.camp.uiSelectOptions.onSelect = function (item) {
        vm.form.camp = item ? item : null;
    };


    vm.requestForm.$fields.userChief.uiSelectOptions.onSelect = function (item, model, options) {
        vm.form.event_application.updateUser(options.index, item);
    };
    vm.requestForm.$fields.userCoach.uiSelectOptions.onSelect = function (item, model, options) {
        vm.form.event_application.updateUser(options.index, item);
    };
    vm.requestForm.$fields.userSafety.uiSelectOptions.onSelect = function (item, model, options) {
        vm.form.event_application.updateUser(options.index, item);
    };
    vm.requestForm.$fields.location.options.ngBlur = function changeLocation() {
        if (vm.form.location) {
            geocoder.getLocationsByAddress(vm.form.location).then(function (response) {
                var marker = {id: 1};

                if (response.result.length > 0) {
                    vm.map.center = geocoder.getLatLngObject(response.result[0].geometry.location);
                    angular.merge(marker, geocoder.getLatLngObject(response.result[0].geometry.location));
                    vm.map.markers = [marker];
                }
            })
        }
    };

    function init() {
        if (arguments.length > 0) {
            vm.form = event.get(arguments[0], vm.eventUserTypes, function () {
                if (vm.form.event_application.documents_files.length > 0) {
                    vm.form.event_application.documents_files.forEach(function (serverFile) {
                        var newFile = new FileUploader.FileItem(vm.requestForm.$fields.documentsFiles.uploader, {
                            lastModifiedDate: new Date(),
                            size: 1e6,
                            name: serverFile.original_name
                        });
                        vm.form.revisor=vm.revisor_id;
                        newFile.progress = 100;
                        newFile.isUploaded = true;
                        newFile.isSuccess = true;
                        newFile.serverData = angular.merge({}, serverFile);

                        vm.requestForm.$fields.documentsFiles.uploader.queue.push(newFile);
                    });
                }

                if (vm.form.coordinates) {
                    vm.map.center = vm.form.coordinates;
                    vm.map.markers = [angular.merge({id: 1}, vm.form.coordinates)];
                }

                if (Object.keys(vm.form.background_image).length) {
                    var backgroundImage = new FileUploader.FileItem(vm.requestForm.$fields.backgroundImage.uploader, {
                        lastModifiedDate: new Date(),
                        size: 1e6,
                        name: vm.form.background_image.image_name
                    });

                    backgroundImage.progress = 100;
                    backgroundImage.isUploaded = true;
                    backgroundImage.isSuccess = true;
                    backgroundImage.serverData = angular.merge({}, vm.form.background_image);

                    vm.requestForm.$fields.backgroundImage.uploader.queue.push(backgroundImage);
                }

                vm.progress = false;
            });
        } else {
            vm.form = event.new({
                type: vm.eventType,
                disciplines: [],
                partners: []
            }, vm.eventUserTypes);

            vm.form.event_application.club = vm.club;
            vm.form.revisor_id=vm.revisor_id;

            vm.updateName();
            vm.progress = false;
        }
    }

    function getDocumentUrl(file_id) {
        return Routing.generate('api_upload_get_file', {fileStorage: file_id});
    }

    function submit() {
        if (vm.submitted || $scope.eventRequestForm.$invalid) {
            console.error($scope.eventRequestForm);

            return;
        }

        vm.submitted = true;
        vm.progress = true;

        if (!vm.form.event_application.accepted) {
            vm.form.event_application.accepted = vm.requestForm.$fields.accepted.items[0];
        }

        if (vm.map.markers.length > 0) {
            vm.form.latitude = vm.map.markers[0].latitude;
            vm.form.longitude = vm.map.markers[0].longitude;
        }

        vm.form.event_application.documents_files = vm.documents_files;

        vm.form.save()
            .then(function (response) {
                if (response.data.id) {
                    $window.location.href = Routing.generate('event_view', {id: response.data.id});
                }
            }, function (response) {
                $log.error(response);

                vm.submitted = false;
                vm.progress = false;
            });
    }

    return vm;
});
